

function ImageBoxFreeContent({ item }) {
    return (
        <div className="flex flex-row-reverse items-center bg-blue-200 rounded p-1 pl-4 mb-1">
            {item === 'اینیستاگرام' ?
                <img src="/image/icon/freeContent/instagram.png" className="w-5" />
                :
                item === 'تلگرام' ?
                    <img src="/image/icon/freeContent/telegram.png" className="w-6" />
                    :
                    item === 'آپارات' ?
                        <img src="/image/icon/freeContent/aparat.png" className="w-6" />
                        :
                        item === 'یوتیوب' ?
                            <img src="/image/icon/freeContent/youtube.png" className="w-6" />
                            :
                            item === 'وب' ?
                                <img src="/image/icon/freeContent/website.png" className="w-6" />
                                :
                                null
            }
            <p className="mr-2 text-xs text-blue-700 font-bold">{item}</p>
        </div>
    )
}
export default ImageBoxFreeContent;